"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomState = void 0;
class RoomState {
    constructor(id, type, onEntered = [], onExited = [], onTick = []) {
        this.id = id;
        this.type = type;
        this.onEntered = onEntered;
        this.onExited = onExited;
        this.onTick = onTick;
        this.meta = {};
        this.actors = [];
        this.state = "Active";
    }
}
exports.RoomState = RoomState;
